var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconSuccessSolid = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 12,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.128 8.018a5.273 5.273 0 1 1 9.744-4.037 5.273 5.273 0 0 1-9.744 4.037m8.077-4.132a.5.5 0 1 0-.785-.62l-3.675 4.65-1.149-1.63a.5.5 0 1 0-.817.575l1.145 1.626a.992.992 0 0 0 1.607.047z",
    clipRule: "evenodd"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 12,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.128 8.018a5.273 5.273 0 1 1 9.744-4.037 5.273 5.273 0 0 1-9.744 4.037m8.077-4.132a.5.5 0 1 0-.785-.62l-3.675 4.65-1.149-1.63a.5.5 0 1 0-.817.575l1.145 1.626a.992.992 0 0 0 1.607.047z",
    clipRule: "evenodd"
  })));
});
export default SvgIconSuccessSolid;
export const raw = __webpack_public_path__ + "static/media/IconSuccessSolid.82e233ca034ef5d7e09a4d61dae733c1.svg";